import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell,
  Chip, Button, Alert, CircularProgress,
} from '@mui/material';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function NetworkMatrix() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get('/network/matrix');
      setData(r.data);
    } catch (e) { /* ignore */ }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const portChips = (ports) => (ports || []).map((p, i) => (
    <Chip key={i} size="small" sx={{ mr: 0.5, mb: 0.5 }}
          label={p.service ? `${p.port} · ${p.service}` : p.port} />
  ));

  if (loading) return <Box sx={{ p: 3 }}><CircularProgress /></Box>;
  const d = data || {};
  const edges = d.edges || [];
  const external = d.external || [];

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1, flexWrap: 'wrap' }}>
        <Typography variant="h5">Матрица доступности (наблюдаемая)</Typography>
        <Button size="small" variant="outlined" onClick={load}>Обновить</Button>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Строится по реальным соединениям, которые агенты видят на самих ПК — кто с кем
        фактически общается и по каким портам. Дополняет «расчётную» матрицу (которая
        выводится из введённых связей) фактом из жизни.
      </Typography>

      {(edges.length === 0 && external.length === 0) ? (
        <Alert severity="info">
          Пока нет данных. Установите агент на компьютеры (карточка устройства → «Агент» →
          «Подключить агент») — он сам пришлёт свои соединения, и матрица заполнится.
        </Alert>
      ) : (
        <>
          <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
            <Chip label={`Агентов прислало: ${d.reporter_count || 0}`} />
            <Chip color="primary" label={`Связей устройство↔устройство: ${d.internal_pairs || 0}`} />
            <Chip variant="outlined" label={`Внешних адресов: ${d.external_targets || 0}`} />
          </Box>

          <Paper variant="outlined" sx={{ mb: 3 }}>
            <Box sx={{ p: 1.5, fontWeight: 600 }}>Внутри сети (устройство → устройство)</Box>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Источник</TableCell>
                  <TableCell>Назначение</TableCell>
                  <TableCell>Порты / сервисы</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {edges.map((e, i) => (
                  <TableRow key={i} hover>
                    <TableCell><Link to={`/devices/${e.src_id}`} style={{ color: '#1976d2' }}>{e.src}</Link></TableCell>
                    <TableCell><Link to={`/devices/${e.dst_id}`} style={{ color: '#1976d2' }}>{e.dst}</Link></TableCell>
                    <TableCell>{portChips(e.ports)}</TableCell>
                  </TableRow>
                ))}
                {edges.length === 0 && (
                  <TableRow><TableCell colSpan={3}>
                    <Typography variant="body2" color="text.secondary">Связей между известными устройствами пока не видно.</Typography>
                  </TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </Paper>

          {external.length > 0 && (
            <Paper variant="outlined">
              <Box sx={{ p: 1.5, fontWeight: 600 }}>Наружу (на внешние / ещё не заведённые адреса)</Box>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Источник</TableCell>
                    <TableCell>Адрес</TableCell>
                    <TableCell>Порты / сервисы</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {external.slice(0, 300).map((e, i) => (
                    <TableRow key={i} hover>
                      <TableCell><Link to={`/devices/${e.src_id}`} style={{ color: '#1976d2' }}>{e.src}</Link></TableCell>
                      <TableCell sx={{ fontFamily: 'monospace' }}>{e.dst_ip}</TableCell>
                      <TableCell>{portChips(e.ports)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          )}
        </>
      )}
    </Box>
  );
}
